import { useState } from "react";
import { Share2, Link2, Check, Send } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden><path d="M18.9 2H22l-7.2 8.2L23 22h-6.6l-5.2-6.8L5.3 22H2.2l7.7-8.8L1.8 2h6.7l4.7 6.2L18.9 2zm-1.2 18h1.8L7.4 3.9H5.5L17.7 20z" /></svg>
);

const trim = (s, n) => (s.length <= n ? s : s.slice(0, n - 1).replace(/\s+\S*$/, "") + "…");

// Share link points at the backend OG page so X/Telegram/etc. show headline, image and STXOSHI's Take.
export const NewsShareBar = ({ article }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = `${API}/api/share/news/${article.slug}`;
  const take = article.ai_take || article.summary || "";
  const xText = `${article.title}\n\nSTXOSHI's Take: ${trim(take, Math.max(60, 250 - article.title.length - 40))}\n\nvia @stxoshi_TOK`;
  const enc = encodeURIComponent;
  const links = [
    { key: "x", label: "Post on X", icon: <XIcon />, href: `https://x.com/intent/tweet?text=${enc(xText)}&url=${enc(shareUrl)}` },
    { key: "telegram", label: "Telegram", icon: <Send className="h-4 w-4" />, href: `https://t.me/share/url?url=${enc(shareUrl)}&text=${enc(`${article.title} — STXOSHI's Take`)}` },
  ];

  const copy = async () => {
    await navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    toast.success("Share link copied");
    setTimeout(() => setCopied(false), 2000);
  };

  const nativeShare = () =>
    navigator.share({ title: article.title, text: `STXOSHI's Take: ${trim(take, 200)}`, url: shareUrl }).catch(() => {});

  const btn = "inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-medium text-white/90 hover:border-primary hover:text-primary transition-colors";

  return (
    <div className="mt-6 flex flex-wrap items-center gap-2" data-testid="news-share-bar">
      {links.map((l) => (
        <a key={l.key} href={l.href} target="_blank" rel="noopener noreferrer" className={btn} data-testid={`news-share-${l.key}`}>
          {l.icon}{l.label}
        </a>
      ))}
      <button type="button" onClick={copy} className={btn} data-testid="news-share-copy">
        {copied ? <Check className="h-4 w-4" /> : <Link2 className="h-4 w-4" />}{copied ? "Copied" : "Copy link"}
      </button>
      {typeof navigator !== "undefined" && navigator.share && (
        <button type="button" onClick={nativeShare} className={btn} data-testid="news-share-native">
          <Share2 className="h-4 w-4" />Share
        </button>
      )}
    </div>
  );
};
